<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import SkiDatePicker from '../../../components/ski/rental/SkiDatePicker';
import i18n from '../../../i18n';
import numberMixin from '../../../mixins/numberMixin';

export default {
  name: 'SkiRentalSeasonPriceSettings',
  props: {
    seasonId: {
      type: [Number, String],
      default: null,
    },
    new: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SkiDatePicker,
  },
  mixins: [
    numberMixin,
  ],
  data() {
    return {
      seasonItem: Object.assign({}, this.season),
      currentPeriodItem: undefined,
      availableNetOrGross: [
        {
          id: 'net',
          name: 'Net',
        },
        {
          id: 'gross',
          name: 'Gross',
        },
      ],
      doRedirectToNewSeason: false,
    };
  },
  computed: {
    ...mapGetters({
      suppliers: 'skirental/getSkiSuppliers',
      periodDates: 'skirental/getPeriodDates',
      availableSalesRules: 'skirental/getSalesTypes',
    }),
    ...mapState({
      season: state => state.skirental.season,
      newPeriodItem: state => state.skirental.season.periodDates.newPeriodItem,
      seasonItemsLoading: state => state.skirental.season.itemsLoading,
      seasonItemsError: state => state.skirental.season.itemsError,
      seasonSaveLoading: state => state.skirental.season.saveLoading,
      seasonSaveError: state => state.skirental.season.saveError,
      suppliersLoading: state => state.skirental.suppliers.itemsLoading,
      suppliersError: state => state.skirental.suppliers.itemsError,
      salesTypesLoading: state => state.skirental.salesTypes.itemsLoading,
      salesTypesError: state => state.skirental.salesTypes.itemsError,
      periodDatesLoading: state => state.skirental.season.periodDates.itemsLoading,
      periodDatesSaveLoading: state => state.skirental.season.periodDates.saveLoading,
    }),
    errorOccurred() {
      return this.seasonItemsError || this.seasonSaveError || this.salesTypesError;
    },
    selectSupplierLabel() {
      const totalSuppliers = Object.keys(this.suppliers).length;
      return totalSuppliers
        ? '(found '.concat(totalSuppliers.toString()).concat(' suppliers)')
        : '';
    },
    isNewPeriodDateActive() {
      return this.periodDates.some(periodDate => periodDate.id === undefined);
    },
  },
  watch: {
    season: {
      deep: true,
      handler() {
        if (this.doRedirectToNewSeason
          && this.seasonItem.id === undefined
          && this.season.id !== undefined) {
          this.doRedirectToNewSeason = false;
          this.$router.push(`/ski/rental/season/${this.season.id}`);
          this.$emit('newSeasonCreated', { seasonId: this.season.id });
        }
        this.seasonItem = Object.assign({}, this.season);
      },
    },
  },
  methods: {
    ...mapActions({
      loadSeason: 'skirental/seasonWithRelationsBySeasonIdLoad',
      loadPeriodDates: 'skirental/periodDatesByIdLoad',
      loadSuppliers: 'skirental/suppliersLoad',
      loadAvailableSalesTypes: 'skirental/salesTypesLoad',
      setSeason: 'skirental/setSeason',
      createSeason: 'skirental/seasonCreate',
      saveSeason: 'skirental/seasonSave',
      setPeriodDateItem: 'skirental/setPeriodDateItem',
      periodDateAddNew: 'skirental/periodDateAddNew',
      periodDateCreate: 'skirental/periodDateCreate',
      removePeriodDate: 'skirental/periodDateRemove',
    }),
    createOrUpdate() {
      if (this.seasonItem.id) {
        this.saveSeason(this.seasonItem);
      } else if (this.createSeason(this.seasonItem)) {
        this.doRedirectToNewSeason = true;
      }
    },
    doRefresh() {
      this.loadSeason(this.season.id);
      this.loadPeriodDates(this.season.id);
    },
    allowedPeriodDates(date) {
      return this.currentPeriodItem && date >= this.currentPeriodItem.arrivalFrom;
    },
    onChange(payload) {
      this.setSeason(payload);
    },
    onPeriodChange(params) {
      let periodDateItem = Object.assign({}, params.periodDate);
      periodDateItem = {
        ...periodDateItem,
        ...params.params,
      };
      let parameters = Object.assign({}, params.params);
      if (params.params.arrivalFrom
        && (params.params.arrivalFrom > periodDateItem.arrivalTo
          || periodDateItem.arrivalTo === undefined
        )
      ) {
        periodDateItem.arrivalTo = params.params.arrivalFrom;
        const arrivalToParams = {
          arrivalTo: params.params.arrivalFrom,
        };
        parameters = {
          ...parameters,
          ...arrivalToParams,
        };
      }
      this.currentPeriodItem = periodDateItem;
      this.setPeriodDateItem(
        {
          periodItem: params.periodDate,
          params: parameters,
        },
      );
    },
    periodDateRemove(periodDate) {
      // eslint-disable-next-line no-alert
      if (!periodDate.id || confirm(i18n.t('ski.skiPeriodDate.removeAreYouSure'))) {
        this.removePeriodDate(
          {
            seasonId: periodDate.skiRentalSeasonId,
            periodId: periodDate.id,
          },
        );
      }
    },
    formatDate(date) {
      return date ? this.$moment(date).format('DD-MM-YY') : '';
    },
    onChangeDecimal(key, value) {
      const payload = {};
      payload[key] = parseFloat(value.replace(',', '.'));
      this.onChange(payload);
    },
    formatDecimal(value) {
      return `${value}`.replace('.', ',');
    },
  },
  mounted() {
    if (this.season.id) {
      store.dispatch('skirental/seasonWithRelationsBySeasonIdLoad', this.season.id)
        .finally(() => {
          store.dispatch('skirental/periodDatesByIdLoad', this.season.id)
            .finally(() => {
            });
        });
    } else {
      this.seasonItem = Object.assign({}, this.season);
    }
    if (!this.suppliers.length) {
      this.loadSuppliers();
    }
    if (!this.availableSalesRules.length) {
      this.loadAvailableSalesTypes();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.params).length === 0 || to.params.new !== undefined) {
      store.dispatch('skirental/seasonByIdLoad', undefined)
        .finally(() => {
          next();
        });
    }

    if (to.params.seasonId) {
      store.dispatch('skirental/seasonWithRelationsBySeasonIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>

<template>
  <v-container class="pa-0 pl-4 skirental-season" grid-list-xl>
    <h2 class="d-inline-block">
      {{
        this.seasonItem.id
          ? $t('ski.skiPriceSettings.title')
          : $t('ski.skiPriceSettings.newSeason')
      }}
    </h2>
    <v-btn
      @click="doRefresh()"
      :loading="seasonItemsLoading"
      icon
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <div class="text-center pa-1">
      <v-progress-linear
        v-if="this.seasonItemsLoading
          || this.seasonSaveLoading
          || this.suppliersLoading
          || this.salesTypesLoading
          || this.periodDatesLoading
        "
        :indeterminate="true"
      />
    </div>
    <v-alert
      :value="this.errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"></span>
    </v-alert>
    <v-flex xs6>
      <v-text-field
        @input="onChange({ name: $event })"
        :label="$t('ski.skiArea.label')"
        :value="seasonItem.name"
      />
    </v-flex>
    <v-layout>
      <v-flex xs3 md3>
        <v-switch
          @change="onChange({ webActive: $event })"
          :label="$t('ski.skiArea.showOnWeb')"
          :input-value="seasonItem.webActive"
        />
      </v-flex>
      <v-flex xs3 md3>
        <v-switch
          @change="onChange({ active: $event })"
          :label="$t('ski.skiPriceSettings.pricesActive')"
          :input-value="seasonItem.active"
        />
      </v-flex>
    </v-layout>
    <h3>{{ $t('ski.skiPriceSettings.supplier') }}</h3>
    <v-layout>
      <v-flex sm5 xs5>
        <v-autocomplete
          @change="onChange({ twentySupplierId: $event })"
          :value="seasonItem.twentySupplierId"
          :items="this.suppliers"
          :loading="suppliersLoading"
          :disabled="suppliersLoading"
          :label="selectSupplierLabel"
          item-text="name"
          item-value="id"
          clearable
        ></v-autocomplete>
      </v-flex>
      <v-flex sm2 xs2>
        <v-select
          @change="onChange({ netOrGross: $event })"
          :value="seasonItem.netOrGross"
          :items="availableNetOrGross"
          :label="$t('ski.skiPriceSettings.netOrGross')"
          item-text="name"
          item-value="id"
          hide-details
        />
      </v-flex>
      <v-flex sm2 xs2>
        <v-text-field
          v-if="seasonItem.netOrGross === 'gross'"
          @change="onChange({ commissionRatio: $event })"
          :value="seasonItem.commissionRatio"
          :placeholder="$t('ski.skiPriceSettings.commission')"
          :label="$t('ski.skiPriceSettings.percentageCommission')"
          type="Number"
          min="0"
          hide-details
        />
        <v-text-field
          v-if="seasonItem.netOrGross === 'net'"
          @change="onChange({ contributionRatio: $event })"
          :value="seasonItem.contributionRatio"
          :placeholder="$t('ski.skiPriceSettings.contribution')"
          :label="$t('ski.skiPriceSettings.percentageContribution')"
          type="Number"
          min="0"
          hide-details
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm3 xs3>
        <v-select
          @change="onChange({ salesRule: $event })"
          :value="seasonItem.salesRule"
          :items="this.availableSalesRules"
          :loading="salesTypesLoading"
          :label="$t('ski.skiPriceSettings.rule')"
          item-text="name"
          item-value="id"
          hide-details
        />
      </v-flex>
      <v-flex sm2 xs2>
        <v-text-field
          @change="onChangeDecimal('priceAdjustmentValue', $event)"
          :value="formatDecimal(seasonItem.priceAdjustmentValue)"
          label="Price Adjustment Value"
          hint="This value is multiplied with all prices prior to any calculations"
          persistent-hint
          reverse
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs2 md3>
        <v-text-field
          @change="onChange({ bookDaysBeforeArrival: $event })"
          :value="seasonItem.bookDaysBeforeArrival"
          label="Book days before arrival"
          type="Number"
          min="0"
          hide-details
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm8>
        <v-textarea
          @change="onChange({ informationText: $event })"
          :value="seasonItem.informationText"
          label="Customer information text"
          box
        />
      </v-flex>
    </v-layout>
    <div class="text-xs-right pr-3">
      <v-btn
        @click="createOrUpdate"
        :disabled="seasonSaveLoading"
        color="primary"
      >
        {{ this.seasonItem.id ? $t('buttons.save') : $t('buttons.create') }}
      </v-btn>
    </div>
    <v-flex sm8 xs8>
      <h3 class="d-inline-block">{{ $t('ski.skiPriceSettings.periodDates') }}</h3>
      <v-btn
        @click="this.periodDateAddNew"
        :disabled="!this.season.id
            || this.isNewPeriodDateActive
            || this.periodDatesLoading
            || this.periodDatesSaveLoading
          "
        class="mb-2"
        color="success"
        small
        outline
      >
        {{ $t('ski.skiPeriodDate.new') }}
      </v-btn>
      <v-flex class="text-xs-right" md8 xs8>
        <div class="text-center">
          <v-progress-linear
            v-if="seasonItemsLoading || periodDatesLoading || periodDatesSaveLoading"
            :indeterminate="true"
          />
        </div>
      </v-flex>
      <v-flex
        v-if="!periodDates.length"
        v-show="!seasonItemsLoading && !periodDatesLoading && !periodDatesSaveLoading"
        xs12
        md3
      >
        <v-chip
          color="red"
          class="text"
          size="1"
          outline
        >
          {{ this.season.id
            ? $t('ski.skiPriceSettings.noPeriodDatesFound')
            : $t('ski.skiPriceSettings.pleaseCreateSeasonBeforePeriodDates')
          }}
        </v-chip>
      </v-flex>
      <v-layout
        v-for="(periodDate, index) in periodDates"
        :key="'ski-period-date-' + index"
        class="ma-2"
        xs12 fill-height row
      >
        <v-layout v-if="periodDate.id">
          <v-flex class="text-xs-right" md2 xs12>
            <v-chip
              v-if="periodDate.isActive"
              color="green"
              class="text"
              size="3"
              small
              outline
            >
              {{ $t('ski.skiPriceSettings.active') }}
            </v-chip>
            <v-chip
              v-else
              color="red"
              class="text"
              size="1"
              small
              outline
            >
              {{ $t('ski.skiPriceSettings.historically') }}
            </v-chip>
          </v-flex>
          <v-flex class="text-md-center" sm3 xs12>
            {{ formatDate(periodDate.arrivalFrom) }} / {{ formatDate(periodDate.arrivalTo) }}
          </v-flex>
          <v-flex sm2 xs12>
            <v-btn
              @click="periodDateRemove(periodDate)"
              :disabled="periodDatesSaveLoading"
              color="error"
              small
              outline
            >
              {{ $t('buttons.remove') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-else>
          <v-flex class="text-xs-right" xs12 md3 offset-sm1>
            <ski-date-picker
              @onChange="onPeriodChange({ periodDate, params: { arrivalFrom: $event }})"
              :date.sync="periodDate.arrivalFrom"
              :title="$t('skiRental.dataHeaders.arrivalFrom')"
              :disabled="periodDatesLoading || periodDatesSaveLoading"
            />
          </v-flex>
          <v-flex xs12 md3>
            <ski-date-picker
              @onChange="onPeriodChange({ periodDate, params: { arrivalTo: $event }})"
              :date.sync="periodDate.arrivalTo"
              :allowed-dates="allowedPeriodDates"
              :title="$t('skiRental.dataHeaders.arrivalTo')"
              :disabled="
                periodDate.arrivalFrom === undefined
                || periodDatesLoading
                || periodDatesSaveLoading
              "
            />
          </v-flex>
          <v-flex sm2 xs12>
            <v-btn
              @click="periodDateCreate(periodDate)"
              :disabled="periodDatesSaveLoading || !periodDate.arrivalFrom || !periodDate.arrivalTo"
              color="green"
              small
              outline
            >
              {{ $t('buttons.create') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<style lang="scss">
  .skirental-season {
    .v-messages {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ski/rental/SkiRentalSeasonPriceSettings.vue